import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './App.scss';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Works from './components/Works';
import About from './components/About';
import Approach from './components/Approach';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProjectPage from './components/ProjectPage';
import ProjectsPage from './components/ProjectsPage';
import PageTransition from './components/PageTransition';
import ScrollToTop from './components/ScrollToTop';

const HomePage = () => (
  <PageTransition>
    <Nav />
    <Hero />
    <Works />
    <About />
    <Approach />
    <Contact />
    <Footer />
  </PageTransition>
);

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <>
    <ScrollToTop />
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/projets" element={
          <PageTransition>
            <ProjectsPage />
          </PageTransition>
        } />
        <Route path="/projet/:slug" element={
          <PageTransition>
            <ProjectPage />
          </PageTransition>
        } />
      </Routes>
    </AnimatePresence>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;
